import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt } from 'react-router';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { cancelRequest } from '../../../services/request.service';
import ReactToPrint from 'react-to-print';
import renderHTML from 'react-render-html';

import BillGridSection from './lis-bill-grid';
import SelectorSection from './lis-selectors';
import ReviewSection from '../../lis-version-management/components/lis-review';

import { sortLegislations } from '../../../services/legislation-helper-service';

class AmendmentManagement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            billFieldsetIsActive: true,
            reviewFieldsetIsActive: false,
            sessionOptions: [],
            selectedSession: '',
            reviewContent: '',
            isLoaded: true,
            billList: [],
            selectedAmendment: '',
            isPreviewVisible: false,
            processingFile: false,
            billDataIsLoading: null,
            billFilter: '',
            sessionID: '',
            selectedChamber: '',
            chamberOptions: [],
            expandedBills: {},
            isDirty: false,
            firstPass: true,
            currentPage: 0,
            pageSize: 5,
            unpublished: false,
            wasEmpty: false,
            replaced: false
        };

        this.reviewRef = React.createRef();

        this.togglePreview = this.togglePreview.bind(this);
        this.toggleFieldsetCollapse = this.toggleFieldsetCollapse.bind(this);
        this.handleSessionChange = this.handleSessionChange.bind(this);
        this.handleChamberChange = this.handleChamberChange.bind(this);
        this.selectAmendment = this.selectAmendment.bind(this);
        this.filterBills = this.filterBills.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.toggleExpandedBills = this.toggleExpandedBills.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onPageSizeChange = this.onPageSizeChange.bind(this);
        this.getEDoc = this.getEDoc.bind(this);
        this.appendEdoc = this.appendEdoc.bind(this);
        this.setWasEmpty = this.setWasEmpty.bind(this);
        this.setReplaced = this.setReplaced.bind(this);
        this.filterToEDocReady = this.filterToEDocReady.bind(this);
        this.isEDocReady = this.isEDocReady.bind(this);
        this.handleNavigateBack = this.handleNavigateBack.bind(this);
    }

    handleNavigateBack() {
        const split = window.location.pathname.split('/');
        const theLastOne = split[split.length - 1];

        if (this.state.isPreviewVisible) {
            this.setState({
                isPreviewVisible: false
            })
            const newPath = '/amendment-management/' + this.state.selectedAmendment.SessionCode + "/" + this.state.selectedAmendment.DocumentCode;
            window.history.pushState({}, '', newPath);
        } else if (/\b\d+\b/.test(theLastOne)) { //Leaving both clauses in case this needs to be refactored in some way
            this.props.history.goBack();
        } else if (theLastOne && ['HB', 'SB', 'HJ', 'SJ', 'HR', 'SR'].find(s => theLastOne.includes(s))) {
            this.props.history.goBack();
        }
    }

    toggleFieldsetCollapse(isActive) {
        this.setState(state => ({
            [isActive]: !state[isActive]
        }));
    }

    togglePreview() {
        this.setState(state => ({
            isPreviewVisible: !state.isPreviewVisible
        }));
    }

    setWasEmpty(val, callback) {
        this.setState({ wasEmpty: val }, () => {
            if (callback) {
                callback();
            }
        })
    }

    setReplaced(val, callback) {
        this.setState({ replaced: val }, () => {
            if (callback) {
                callback();
            }
        })
    }

    async handleSave(publish) {
        this.setState({ isSaving: true });

        let selectedAmendment = { ...this.state.selectedAmendment };
        let amendmentsToSave = [];

        //Try to find the draft title in the text and set it
        let domContainer = document.createElement('div');
        domContainer.innerHTML = this.state.reviewContent;
        //The first element in the content with this class is the draft title
        let draftLDTitle = domContainer.querySelector('.ldtitle');
        if (draftLDTitle && draftLDTitle.innerHTML !== '') {
            selectedAmendment.DraftTitle = draftLDTitle.innerHTML;
        }

        //Remove any tags TinyMCE may have added when pasting from Word (Borrowing DOM container)
        domContainer.childNodes.forEach(node => {
            if (node.nodeName !== "#text") {
                node.removeAttribute('data-mce-fragment');
                if (node.childNodes.length > 0) {
                    node.childNodes.forEach(childNode => {
                        if (childNode.nodeName !== "#text") {
                            childNode.removeAttribute('data-mce-fragment');
                        }
                    })
                }
            }
        });

        selectedAmendment.DraftText = domContainer.innerHTML;
        selectedAmendment.IsPublic = publish || false;

        if (!selectedAmendment.LegislationTypeCode) {
            selectedAmendment.LegislationTypeCode = this.state.billList.find(x => x.LegislationID === selectedAmendment.LegislationID).LegislationTypeCode
        }

        if (!selectedAmendment.LegislationChamberCode) {
            selectedAmendment.LegislationChamberCode = selectedAmendment.ChamberCode;
        }

        //If we're publishing the engrossed collection of adopted/adopted in part amendments then mark all of those amendments inactive and add them to the save array
        if (publish && Boolean(selectedAmendment.Description.match(/((Senate)|(House))\s(Amendment)s?/)) && selectedAmendment.TextDispositionID === 12) {
            let bill = this.state.billList.find(x => x.LegislationID === selectedAmendment.LegislationID);
            for (let i = 0; i < bill.Amendments.length; i++) {
                if (bill.Amendments[i].TextDispositionID !== 12) {
                    if ((bill.Amendments[i].TextDispositionID === 6 || bill.Amendments[i].TextDispositionID === 7) && bill.Amendments[i].IsActive) {
                        //Missing draft text can cause republish to fail
                        if (!bill.Amendments[i].DraftText) {
                            await this.props.actions.getBillText("?legislationTextID=" + bill.Amendments[i].LegislationTextID, true)
                                .then(() => {
                                    bill.Amendments[i] = this.props.bills.billText[0]
                                })
                        }
                        bill.Amendments[i].IsActive = false;

                        amendmentsToSave.push(bill.Amendments[i])
                    };
                }
            }
        }

        amendmentsToSave.push(selectedAmendment)

        this.props.actions.saveBillText({ TextsList: amendmentsToSave.filter(x => x.LegislationVersionID === 8) })
            .then(() => {
                this.setState({ isSaving: false });
                //In instances where we're publishing the engrossed version, other versions (like introduced) were present in the response
                //Filter out anything that ins't an amendment so we don't fall into the exception throw
                let billTextSave = [...this.props.bills.billTextSave.filter(x => x.LegislationVersionID === 8)];
                if (!billTextSave.length) {
                    throw 'The response does not contain a bill text';
                }
                //If only one bill text is returned, use that one, otherwise, use the engrossed one (if there is more than one bill text returned and there is not exactly one engrossed version, there is an issue)
                if (billTextSave.length > 1) {
                    billTextSave = billTextSave.filter(x => x.TextDisposition === "Engrossed");
                }
                if (billTextSave.length !== 1) {
                    throw 'The response contains more than one bill text, but not exactly one engrossed version';
                }
                if (publish) {
                    this.setState({
                        isPreviewVisible: false,
                        selectedAmendment: '',
                        reviewContent: '',
                        reviewFieldsetIsActive: false,
                        billFieldsetIsActive: true,
                        isDirty: false,
                        firstPass: true
                    });
                    let filtered = this.state.filteredBillList.length != this.state.billList.length ? true : false
                    let billList = filtered ? [...this.state.filteredBillList] : [...this.state.billList];
                    const publishedBillIndex = billList.findIndex(b => b.LegislationID === billTextSave[0].LegislationID)
                    this.handleSessionChange(this.state.selectedSession, publishedBillIndex);
                    const legFileGenParams = "?legislationID=" + billTextSave[0].LegislationID
                        + "&legislationTextID=" + billTextSave[0].LegislationTextID
                        + "&legislationVersionID=" + billTextSave[0].LegislationVersionID
                        + "&sessionID=" + this.state.selectedSession.SessionID;
                    this.props.actions.genBillFile(legFileGenParams)
                } else {
                    this.setState({
                        selectedAmendment: billTextSave[0],
                        isDirty: false,
                        firstPass: true
                    });
                }
                this.props.actions.makeToast([{ message: "Save Successful", type: "success" }]);
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err.toString());
                this.props.actions.makeToast([{ message: "Save Failed. You may need to refresh before attempting to save.", type: "failure" }]);
                this.setState({ isSaving: false });
            });
    }

    handleEditorChange(content) {
        this.setState({
            reviewContent: content,
            isDirty: this.state.firstPass ? false : true,
            firstPass: false
        });
    }

    handleSessionChange(val, publishedLegislationIndex, onMount) {
        this.setState({
            selectedSession: val,
            isLoaded: false,
            selectedBill: '',
            amendmentFieldsetIsActive: false,
            reviewFieldsetIsActive: false
        });
        let params = "?sessionID=" + val.SessionID;
        if (this.state.selectedChamber.value) {
            params = params + "&chamberCode=" + this.state.selectedChamber.value;
        }
        this.props.actions.getLegislationAmendmentList(params)
            .then(() => {
                this.setState({
                    billList: this.props.bills.legislationAmendmentList,
                    isLoaded: true,
                    sessionID: val.SessionID
                }, () => {
                    const callback = () => {
                        if (!isNaN(publishedLegislationIndex) && publishedLegislationIndex > -1) {
                            this.createEDoc(publishedLegislationIndex);
                        }
                        //create e doc for bills that were expanded;
                        //if we are viewing bills ready for eDoc, then the bill just published will be removed so we also need to reset expandedBills state accordingly
                        let newExpanded = { ...this.state.expandedBills };
                        Object.entries(this.state.expandedBills).forEach((b, i) => {
                            const idx = Number(b[0]);
                            const expanded = b[1];
                            if (this.state.eDocFiltered && !isNaN(publishedLegislationIndex) && publishedLegislationIndex > -1 && idx >= publishedLegislationIndex) {
                                if (idx !== publishedLegislationIndex) { newExpanded[idx - 1] = expanded; }
                                delete newExpanded[idx];
                                if (expanded) {
                                    this.createEDoc(idx - 1);
                                }
                            } else if (expanded) {
                                this.createEDoc(idx);
                            }
                        })
                        this.setState({ expandedBills: newExpanded });
                    }
                    if (this.state.billFilter) {
                        this.filterBills({ target: { value: this.state.billFilter } }, (publishedLegislationIndex ? true : false), callback)
                    } else {
                        this.setState({
                            filteredBillList: this.props.bills.legislationAmendmentList
                        }, () => {
                            callback();
                        })
                    }
                    if (this.state.eDocFiltered) {
                        this.filterToEDocReady()
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                this.setState({
                    isLoaded: true
                });
            });
    }

    handleChamberChange(val) {
        this.setState({
            selectedChamber: val,
        });
        if (this.state.sessionID) {
            const params = "?sessionID=" + this.state.sessionID + "&chamberCode=" + val.value;
            this.setState({
                isLoaded: false,
                selectedBill: '',
                amendmentFieldsetIsActive: false,
                reviewFieldsetIsActive: false,
                expandedBills: {}
            }, () => {
                this.props.actions.getLegislationAmendmentList(params)
                    .then(() => {
                        this.setState({
                            billList: this.props.bills.legislationAmendmentList,
                            isLoaded: true
                        }, () => {
                            if (this.state.billFilter) {
                                this.filterBills({ target: { value: this.state.billFilter } })
                            } else {
                                this.setState({
                                    filteredBillList: this.props.bills.legislationAmendmentList
                                })
                            }
                            if (this.state.eDocFiltered) {
                                this.filterToEDocReady()
                            }
                        });
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        this.setState({
                            isLoaded: true
                        });
                    });
            })
        }
    }

    async appendEdoc(amendment, amendments) {
        let draftText = amendment.DraftText;
        let amendmentNumber = 1;
        let amendmentTexts = [];
        let amendmentItems = [];

        for (let i = 0; i < amendments.length; i++) {
            if (amendments[i].IsActive) {
                let billTextParams = "?legislationTextID=" + amendments[i].LegislationTextID;
                await this.props.actions.getBillText(billTextParams, true)
                    .then(() => {
                        amendmentTexts.push(this.props.bills.billText[0]);
                    })
            }
        }

        await amendmentTexts.forEach((amendmentText, i) => {
            amendmentItems.push(...amendmentText.AmendmentItems)
        })

        await amendmentItems.sort((a, b) => {
            return a.LineNumber - b.LineNumber
        })

        for (let k = 0; k < amendmentItems.length; k++) {
            let thisDraftText = '';
            //Sponsor
            thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].Sponsor.ClassName + '">' + amendmentItems[k].Sponsor.Name + '</p>';
            //Line
            thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].LineClassName + '">' + (amendmentNumber) + ". " + amendmentItems[k].Line + '</p>';
            amendmentNumber++;
            //Changes
            if (amendmentItems[k].amendmentChanges) {
                for (let l = 0; l < amendmentItems[k].amendmentChanges.length; l++) {
                    for (let m = 0; m < amendmentItems[k].amendmentChanges[l].AmendmentActions.length; m++) {
                        if (amendmentItems[k].amendmentChanges[l].AmendmentActions[m].text !== "") {
                            thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].amendmentChanges[l].ClassName + '">' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].action + '</p>';
                            thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].TextClassName + '">' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].text + '</p>';
                        } else {
                            thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].amendmentChanges[l].ClassName + '">' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].action + '</p>';
                            for (let n = 0; n < amendmentItems[k].amendmentChanges[l].AmendmentActions[m].Lines.length; n++) {
                                thisDraftText = thisDraftText + '<p class="' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].TextClassName + '">' + amendmentItems[k].amendmentChanges[l].AmendmentActions[m].Lines[n] + '</p>';
                            }
                        }
                    }
                }
            }

            //We check to see if the exact amendment text already exists in the edoc. If it does then skip over it so as to not add it into the edoc a second time
            if (draftText.replace(/(\r\n|\n|\r)/gm, "").indexOf(thisDraftText) === -1) {
                draftText = draftText + thisDraftText;
            }
        }

        amendment.DraftText = draftText;
        amendment.AmendmentItems = amendmentItems

        return amendment;
    }

    async getEDoc(billTextParams) {
        await this.props.actions.getBillText(billTextParams, true)
        return this.props.bills.billText[0];
    }

    async selectAmendment(billIndex, amendment) {
        const newPath = '/amendment-management/' + this.state.selectedSession.SessionCode + "/" + amendment.DocumentCode;
        window.history.pushState({}, '', newPath);
        //If the amendment has a LegislationTextID then fetch it and start editing
        if (amendment.LegislationTextID && amendment.TextDispositionID !== 12) {
            let billTextParams = "?legislationTextID=" + amendment.LegislationTextID;
            this.setState({
                billDataIsLoading: billIndex
            });
            this.props.actions.getBillText(billTextParams, true)
                .then(() => {
                    if (this.props.bills.billText.length === 0) {
                        throw 'No bill text found for this text ID';
                    }
                    if (this.props.bills.billText.length > 1) {
                        throw 'There is more than one bill text for this text id';
                    }
                    const amendment = this.props.bills.billText[0];
                    this.setState({
                        wasEmpty: false,
                        replaced: false,
                        billDataIsLoading: null,
                        selectedAmendment: amendment,
                        reviewFieldsetIsActive: true,
                        //billFieldsetIsActive: false,
                        reviewContent: amendment.DraftText || '',
                        isDirty: false,
                        firstPass: true,
                        unpublished: amendment.LegislationTextID && amendment.IsPublic ? false : true
                    }, () => {
                        this.reviewRef.current.scrollIntoView();
                    });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err.toString());
                    this.setState({
                        billDataIsLoading: null
                    });
                    this.props.actions.makeToast([{ message: "Failed to get Bill Text", type: "failure" }]);
                });
        } else if (amendment.TextDispositionID === 12
            && amendment.LegislationTextID //Else if we find an edoc that was previously saved and there is at least one adopted/adopted in part amendment that's still active we need to add it to the edoc
            && (this.state.filteredBillList.length != this.state.billList.length
                ? this.state.filteredBillList[billIndex].Amendments.find(x => x.IsActive && [7, 6].includes(x.TextDispositionID))
                : this.state.billList[billIndex].Amendments.find(x => x.IsActive && [7, 6].includes(x.TextDispositionID)))) {

            this.setState({
                billDataIsLoading: true
            })

            let filtered = this.state.filteredBillList.length != this.state.billList.length;
            let billList = filtered ? [...this.state.filteredBillList] : [...this.state.billList];
            let amendments = billList[billIndex].Amendments.filter(x => x.IsActive && [7, 6].includes(x.TextDispositionID))

            let billTextParams = "?legislationTextID=" + amendment.LegislationTextID;

            //We have to go back across the wire a bunch to fetch the needed edoc draft text and amendment items to build the appended edoc
            //If we didn't use async/await setting the state below outruns the building of the document
            let eDocText = await this.getEDoc(billTextParams);
            let appendedEDoc = await this.appendEdoc(eDocText, amendments);

            amendment = appendedEDoc;

            this.setState({
                billDataIsLoading: null,
                selectedAmendment: amendment,
                reviewFieldsetIsActive: true,
                reviewContent: amendment && amendment.DraftText || '',
                isDirty: false,
                firstPass: true,
                wasEmpty: false,
                replaced: false,
                unpublished: amendment.LegislationTextID && amendment.IsPublic ? false : true
            }, () => {
                this.reviewRef.current.scrollIntoView();
            });
        } else {
            let filtered = this.state.filteredBillList.length != this.state.billList.length;
            let billList = filtered ? [...this.state.filteredBillList] : [...this.state.billList].toSorted(sortLegislations);
            let billTextParams = "?legislationID=" + billList[billIndex].LegislationID;
            let amendmentItems = [];

            this.setState({
                billDataIsLoading: billIndex
            }, () => {
                this.props.actions.getBillText(billTextParams, true)
                    .then(() => {
                        //If we don't have the LegislationTextID then this is an auto-generated document containing all adopted/adopted in part amendments
                        //Build the document to be passed into the editor
                        if (!amendment.LegislationTextID) {
                            for (let i = 0; i < this.props.bills.billText.length; i++) {
                                if (this.props.bills.billText[i].ChamberCode !== billList[billIndex].ChamberCode && (this.props.bills.billText[i].TextDispositionID === 6 || this.props.bills.billText[i].TextDispositionID === 7)) {
                                    for (let j = 0; j < this.props.bills.billText[i].AmendmentItems.length; j++) {
                                        amendmentItems.push(this.props.bills.billText[i].AmendmentItems[j]);
                                    }
                                }
                            }

                            let amendment = billList[billIndex].Amendments.find(x => !x.LegislationTextID);
                            amendment.AmendmentItems = amendmentItems.sort((a, b) => a.LineNumber - b.LineNumber);

                            //Build the doc
                            let draftText = '<p class="textbl">(' + billList[billIndex].LegislationNumber + ')</p> <p class="textbl">AMENDMENT(S) PROPOSED BY THE ' + (billList[billIndex].ChamberCode === 'H' ? 'SENATE' : 'HOUSE') + '</p>';

                            for (let k = 0; k < amendment.AmendmentItems.length; k++) {
                                //Sponsor
                                draftText = draftText + '<p class="' + amendment.AmendmentItems[k].Sponsor.ClassName + '">' + amendment.AmendmentItems[k].Sponsor.Name + '</p>';
                                //Line
                                draftText = draftText + '<p class="' + amendment.AmendmentItems[k].LineClassName + '">' + (k + 1) + ". " + amendment.AmendmentItems[k].Line + '</p>';
                                //Changes
                                if (amendment.AmendmentItems[k] && amendment.AmendmentItems[k].amendmentChanges) {
                                    for (let l = 0; l < amendment.AmendmentItems[k].amendmentChanges.length; l++) {
                                        for (let m = 0; m < amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions.length; m++) {
                                            if (amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].text !== "") {
                                                draftText = draftText + '<p class="' + amendment.AmendmentItems[k].amendmentChanges[l].ClassName + '">' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].action + '</p>';
                                                draftText = draftText + '<p class="' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].TextClassName + '">' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].text + '</p>';
                                            } else {
                                                draftText = draftText + '<p class="' + amendment.AmendmentItems[k].amendmentChanges[l].ClassName + '">' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].action + '</p>';
                                                for (let n = 0; n < amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].Lines.length; n++) {
                                                    draftText = draftText + '<p class="' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].TextClassName + '">' + amendment.AmendmentItems[k].amendmentChanges[l].AmendmentActions[m].Lines[n] + '</p>';
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            amendment.DraftText = draftText;
                            let amendments = this.props.bills.billText.filter(x => x.LegislationVersionID === 8);
                            amendments.push(amendment);
                            //Need to pick out the amendments specifically
                            billList[billIndex].Amendments = amendments
                            //Else if we are opening the edoc and there are previously unpublished adopted/adopted in part amendments present in the list then add them to the edoc
                        } else {
                            amendment = this.props.bills.billText.find(x => x.LegislationTextID === amendment.LegislationTextID)
                            //We only want the amendments
                            billList[billIndex].Amendments = this.props.bills.billText.filter(x => x.LegislationVersionID === 8);
                        }

                        if (filtered) {
                            this.setState({
                                filteredBillList: billList
                            })
                        } else {
                            this.setState({
                                billList: billList
                            })
                        }
                        this.setState({
                            billDataIsLoading: null,
                            selectedAmendment: amendment,
                            reviewFieldsetIsActive: true,
                            //billFieldsetIsActive: false,
                            reviewContent: amendment && amendment.DraftText || '',
                            wasEmpty: false,
                            replaced: false,
                            isDirty: false,
                            firstPass: true,
                            unpublished: amendment.LegislationTextID && amendment.IsPublic ? false : true
                        }, () => {
                            this.reviewRef.current.scrollIntoView();
                        });
                    })
            });

            this.setState({
                billDataIsLoading: false
            })
        }
    }

    filterBills(e, keepExpanded, callback) {
        const val = e?.target?.value?.toUpperCase();
        let filteredBillList = val ? this.state.billList.filter(bill => bill.LegislationNumber.toUpperCase().includes(val)) : this.state.billList;
        const resultsChanged = filteredBillList.length !== this.state.billList.length;
        this.setState({
            filteredBillList: filteredBillList,
            eDocFiltered: false,
            billFilter: val
        }, () => {
            if (resultsChanged) {
                //reset page to 0 since results have changed
                this.onPageChange(0, keepExpanded);
            }
            if (callback)
                callback();
        });
    }

    toggleExpandedBills(newExpanded, pageIndex) {
        let index, billIndex;
        for (let key in newExpanded) {
            //Find the key where the current expanded bills and the new expanded bills differs
            if (newExpanded[key] && !this.state.expandedBills[key] || !newExpanded[key] && this.state.expandedBills[key]) {
                index = key;
                billIndex = parseInt(key) + (parseInt(pageIndex) * this.state.pageSize);
            }
        }

        this.setState({
            expandedBills: newExpanded
        }, () => {
            if (this.state.expandedBills[index]) {
                this.createEDoc(billIndex);
            }
        })
    }

    filterToEDocReady() {
        let billList = [...this.state.billList];

        const filteredBillList = billList.filter((_, billIndex) => this.isEDocReady(billList, billIndex));
        this.setState({ filteredBillList, eDocFiltered: true, billFilter: '' });
    }

    isEDocReady(billList, billIndex) {
        //If we have not already created the new consolidated amendment
        //And If, from the opposing chamber, there is any active Adopted In Part amendment OR there is at least one active Adopted amendment
        //Then create the new consolidated amendment
        const amendmentsFilteredByOpposingChamber = billList[billIndex]?.Amendments?.filter(x => x.ChamberCode !== billList[billIndex].ChamberCode);

        return !amendmentsFilteredByOpposingChamber?.find(x => x.TextDispositionID === 12) &&
            (amendmentsFilteredByOpposingChamber?.find(x => x.TextDispositionID === 7)
                || amendmentsFilteredByOpposingChamber?.find(x => x.TextDispositionID === 6))
    }

    createEDoc(billIndex) {
        let filtered = this.state.filteredBillList.length != this.state.billList.length ? true : false
        let billList = filtered ? [...this.state.filteredBillList] : [...this.state.billList];

        if (this.isEDocReady(billList, billIndex)) {
            let eDoc = {
                ChamberCode: billList[billIndex].ChamberCode === "H" ? "S" : "H", //Opposite of the bill's originating chamber
                Description: (billList[billIndex].ChamberCode === "H" ? "Senate" : "House") + " Amendments", //Opposite of the bill's originating chamber
                DocumentCode: billList[billIndex].LegislationNumber + "EDOC",
                IsActive: true,
                IsPublic: false,
                LDNumber: null,
                LegislationID: billList[billIndex].LegislationID,
                LegislationTextID: null,
                LegislationVersion: "Amendment",
                LegislationVersionID: 8,
                TextDisposition: "Engrossed",
                TextDispositionID: 12,
                VersionDate: "",
                SessionCode: this.state.selectedSession.SessionCode,
                SponsorType: billList[billIndex].ChamberCode === "H" ? "Senate" : "House", //Opposite of the bill's originating chamber
            }
            billList[billIndex].Amendments.push(eDoc)

            if (filtered) {
                this.setState({
                    filteredBillList: billList
                })
            } else {
                this.setState({
                    billList: billList
                });
            }
        }
    }

    componentDidMount() {
        window.addEventListener("popstate", this.handleNavigateBack);
        //Get the list of active sessions for the session dropdown
        this.props.actions.getSessionShallowList("IsActive=true")
            .then(() => {
                let sessionList = [...this.props.session.sessionShallowList];
                sessionList.forEach(session => {
                    session.label = session.SessionYear + ' ' + session.DisplayName;
                    session.value = session.SessionID;
                    //Set the last session in the list as the selected session
                    if (session.IsDefault) {
                        this.handleSessionChange(session, null, true);
                    }
                });
                this.setState({
                    sessionOptions: sessionList
                });
            });

        //Find if user has access to house and/or senate and add option to chamber selector as applicable
        let chamberOptions = [];

        if (this.props.login.userClaims.claims.find(x => x.Resource === "LegislationText" && x.Scope == 'House')) {
            chamberOptions.push({ label: "House Amendment Activity", value: "H" });
        }
        if (this.props.login.userClaims.claims.find(x => x.Resource === "LegislationText" && x.Scope == 'Senate')) {
            chamberOptions.push({ label: "Senate Amendment Activity", value: "S" })
        }

        this.setState({
            chamberOptions: chamberOptions,
            disableChamberSelector: chamberOptions.length === 1
        }, () => {
            if (this.state.chamberOptions.length === 1) {
                this.handleChamberChange(chamberOptions[0])
            }
        })
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.handleNavigateBack);
        cancelRequest();
    }

    onPageChange(pageIndex, keepExpanded) {
        this.setState({
            currentPage: pageIndex
        }, () => {
            //Reset the expanded bills so we don't have bills that weren't clicked on expanded as the user tabs through the pages of the table
            if (!keepExpanded) {
                this.toggleExpandedBills({}, this.state.currentPage)
            }
        })
    }

    onPageSizeChange(pageSize) {
        this.setState({ pageSize: pageSize }, () => {
            this.toggleExpandedBills({}, this.state.currentPage)
        })
    }

    render() {
        const { selectedAmendment } = this.state;
        if (this.state.isPreviewVisible) {
            return (
                <div>
                    <div className="flex-row align-center bottomline">
                        <h2>{this.state.selectedSession.SessionYear} {this.state.selectedSession.DisplayName} / {selectedAmendment.DocumentCode}</h2>
                        <ReactToPrint
                            trigger={() => <span><button type="button" className="button print">Print</button></span>}
                            content={() => this.componentRef}
                            pageStyle={"break-inside: avoid"}
                        />
                    </div>
                    <div className="inner-grid two-col-sidebar" ref={el => (this.componentRef = el)}>
                        <div>
                            {this.state.reviewContent ? renderHTML(this.state.reviewContent) : ''}
                        </div>
                    </div>
                    <div className="button-bar">
                        <div></div>
                        <div className="align-right">
                            <button disabled={this.state.isSaving} onClick={this.togglePreview} className="button secondary">Edit</button>
                            <button disabled={this.state.isSaving} onClick={() => this.handleSave(true)} className="button">{this.state.isSaving ? "Publishing..." : "Publish"}</button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div>
                        <Prompt
                            when={this.state.isDirty}
                            message={`You have unsaved changes. Are you sure you would like to leave?`}
                        />
                    </div>
                    <h1>Amendment Management</h1>
                    <div className="user-forms dlas-forms">
                        <fieldset className={this.state.billFieldsetIsActive ? 'fieldset-collapse fieldset-open' : 'fieldset-collapse fieldset-closed'} >
                            <legend onClick={this.toggleFieldsetCollapse.bind(this, 'billFieldsetIsActive')}>Bills {this.state.processingFile && <span> | <i>Creating file...</i></span>}</legend>
                            <div>
                                <SelectorSection
                                    onSessionChange={this.handleSessionChange}
                                    sessionOptions={this.state.sessionOptions}
                                    selectedSession={this.state.selectedSession}

                                    onChamberChange={this.handleChamberChange}
                                    chamberOptions={this.state.chamberOptions}
                                    selectedChamber={this.state.selectedChamber}
                                    chamberIsDisabled={this.state.disableChamberSelector}

                                    isDisabled={this.state.sessionID === ""}
                                />
                                <span className="insert-message small-text fail">{this.props.bills.legislationAmendmentListError}</span>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input type="text" disabled={!this.state.isLoaded || this.state.eDocFiltered} onChange={this.filterBills} value={this.state.billFilter} placeholder="Filter by bill number" />
                                    <button type="button" className="button" disabled={!this.state.isLoaded} onClick={() => { !this.state.eDocFiltered ? this.filterToEDocReady() : this.filterBills(); this.setState({ expandedBills: {} }) }}>{!this.state.eDocFiltered ? 'Show Bills Ready For Second Chamber Engrossed Doc' : 'All Bills'}</button>
                                </div>
                                <BillGridSection
                                    billList={this.state.filteredBillList && this.state.filteredBillList.toSorted(sortLegislations)}
                                    selectAmendment={this.selectAmendment}
                                    isLoaded={this.state.isLoaded}
                                    billDataIsLoading={this.state.billDataIsLoading}
                                    expandedBills={this.state.expandedBills}
                                    toggleExpandedBills={this.toggleExpandedBills}
                                    pageSize={this.state.pageSize}
                                    currentPage={this.state.currentPage}
                                    onPageChange={this.onPageChange}
                                    onPageSizeChange={this.onPageSizeChange}
                                    selectedChamber={this.state.selectedChamber.value}
                                />
                            </div>
                        </fieldset>
                        <fieldset ref={this.reviewRef} className={this.state.reviewFieldsetIsActive ? 'fieldset-collapse fieldset-open' : 'fieldset-collapse fieldset-closed'} >
                            <legend onClick={this.toggleFieldsetCollapse.bind(this, 'reviewFieldsetIsActive')}><span>Review </span>
                                {selectedAmendment &&
                                    <span>
                                        | {selectedAmendment.DocumentCode}
                                    </span>
                                }</legend>
                            <div>
                                <ReviewSection
                                    editorContent={this.state.reviewContent}
                                    handleEditorChange={this.handleEditorChange}
                                    sessionId={this.state.selectedSession.SessionID}
                                    allowAmendmentActions={true}
                                    userChamber={this.props.login.userClaims.roles.find((x) => x === "Admin") ? "Admin" : this.props.login.userClaims.roles.find((x) => x === "HouseLegislationAuthor") ? "H" : "S"}
                                    billNumber={this.state.selectedAmendment ? this.state.selectedAmendment.LegislationNumber : ''}
                                    location={this.props.location.pathname}
                                    pasteAsText={false}
                                    setWasEmpty={this.setWasEmpty}
                                    wasEmpty={this.state.wasEmpty}
                                    setReplaced={this.setReplaced}
                                    replaced={this.state.replaced}
                                />
                                <div className="button-bar">
                                    <button type='button' className='button primary' style={{ width: "120px" }} onClick={() => this.handleNavigateBack()}>Back to List</button>
                                    <div className="align-right">
                                        <button type="button" className="button" disabled={this.state.isSaving || !this.state.selectedAmendment} onClick={() => this.handleSave(this.state.unpublished ? false : true)}>{this.state.isSaving ? !this.state.unpublished ? "Republishing..." : "Saving..." : !this.state.unpublished ? "Republish" : "Save"}</button>
                                        {this.state.unpublished && <button type="button" className="button" disabled={!this.state.selectedAmendment || this.state.isSaving || this.state.isDirty} onClick={this.togglePreview}>Preview</button>}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            );
        }
    }
}
export default connect(
    (state) => {
        const { bills, session, nav, login } = state;
        return {
            bills,
            session,
            nav,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, billActionCreators, sessionActionCreators, navActionCreators), dispatch)
        }
    }
)(AmendmentManagement)
